module.exports = __webpack_public_path__ + "static/media/raise-or-fold-2-intro-screen.5fc7d722.png";